var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNoseRingR = function SvgNoseRingR(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 28,
    height: 32,
    viewBox: "0 0 0.51 0.59",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.35.05s-.01.1 0 .13c0 .13-.01.05.09.1.03.02.03.07.02.1M.29.53.28.54C.25.54.05.42.05.32.04.25.13.25.17.25.18.22.16.07.17.05",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.09,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.44.36C.49.4.51.44.51.49.5.52.49.55.46.56.44.58.41.59.38.59.34.59.29.56.27.5.24.42.28.39.33.37V.36C.34.36.36.35.38.35.4.35.42.35.44.36zM.4.42C.49.48.38.57.34.47.33.45.35.44.37.43.38.42.39.42.4.42z",
    fill: "#000"
  })));
};

export default SvgNoseRingR;